(function () {
  const initProductFeatureSlideshow = (section) => {
    if (!section || !section?.classList.contains("product-feature-slideshow-section"))
      return;

    const navItems = section.querySelectorAll(".product-feature-slideshow__nav-item");
    const mediaItems = section.querySelectorAll(".product-feature-slideshow__media-item");

    if (!navItems.length || !mediaItems.length) return;

    const nav = section.querySelector(".product-feature-slideshow__nav");
    const media = section.querySelector(".product-feature-slideshow__media");

    const activate = (tabId) => {
      navItems.forEach((item) => {
        const isActive = item.dataset.tabId === tabId;

        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      mediaItems.forEach((item) => {
        item.classList.toggle("is-active", item.dataset.panelId === tabId);
      });
    };

    const getActiveIndex = () =>
      Array.prototype.indexOf.call(
        mediaItems,
        media.querySelector(".product-feature-slideshow__media-item.is-active")
      );

    // Keep the active tab visible when the nav is horizontally scrollable (mobile).
    const scrollNavToActive = () => {
      if (!nav) return;

      const activeItem = nav.querySelector(".product-feature-slideshow__nav-item.is-active");
      if (!activeItem || nav.scrollWidth <= nav.clientWidth) return;

      const target =
        nav.scrollLeft +
        (activeItem.getBoundingClientRect().left - nav.getBoundingClientRect().left) -
        (nav.clientWidth - activeItem.offsetWidth) / 2;

      nav.scrollTo({ left: target, behavior: "smooth" });
    };

    const navigate = (direction) => {
      const activeIndex = getActiveIndex();

      if (activeIndex === -1) return;

      const targetIndex =
        (activeIndex + direction + mediaItems.length) % mediaItems.length;

      activate(mediaItems[targetIndex].dataset.panelId);
      scrollNavToActive();
    };

    navItems.forEach((item) => {
      item.addEventListener("click", () => activate(item.dataset.tabId));
    });

    if (nav) {
      nav.addEventListener("keydown", (event) => {
        const currentIndex = Array.prototype.indexOf.call(navItems, document.activeElement);

        if (currentIndex === -1) return;

        let targetIndex = null;

        if (event.key === "ArrowDown" || event.key === "ArrowRight") {
          targetIndex = (currentIndex + 1) % navItems.length;
        } else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
          targetIndex = (currentIndex - 1 + navItems.length) % navItems.length;
        }

        if (targetIndex === null) return;

        event.preventDefault();
        const targetItem = navItems[targetIndex];
        targetItem.focus();
        activate(targetItem.dataset.tabId);
      });
    }

    // Swipe left/right on the image to change the active feature and sync the nav.
    if (media) {
      let startX = null;
      let startY = null;

      const handleSwipeEnd = (event) => {
        if (startX === null) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        startX = null;
        startY = null;

        const swipeThreshold = 40;

        // Ignore taps and mostly-vertical gestures so page scrolling still works.
        if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        navigate(deltaX < 0 ? 1 : -1);
      };

      media.addEventListener("pointerdown", (event) => {
        startX = event.clientX;
        startY = event.clientY;
      });
      media.addEventListener("pointerup", handleSwipeEnd);
      media.addEventListener("pointercancel", () => {
        startX = null;
        startY = null;
      });
    }
  };

  initProductFeatureSlideshow(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (e) {
    initProductFeatureSlideshow(e.target);
  });
})();
